import classNames from 'classnames';
import { useEffect } from 'react';

import { APIRequestLabel } from '@consts';
import { useStore } from '@store';
import { setupForDark } from '@theme';

export default function MasterHello({ onLoaded }: { onLoaded?: () => void }) {
  const { masterHello, masterSayHello, apiCallStatus } = useStore((state) => ({
    masterHello: state.masterHello,
    masterSayHello: state.masterSayHello,
    apiCallStatus: state.apiCallStatus
  }));

  useEffect(() => {
    masterSayHello();
  }, []);

  const apiStatus = apiCallStatus[APIRequestLabel.MASTER_SAY_HELLO];
  useEffect(() => {
    if (apiStatus.response) {
      onLoaded && onLoaded();
    }
  }, [apiStatus]);

  return (
    apiStatus.response &&
    masterHello && (
      <div className='mx-md mb-lg'>
        <div className={classNames('H6 pb-sm', setupForDark('text-tertiary'))}>
          {masterHello.hi}
        </div>
        <div className={classNames('H4', setupForDark('text-primary'))}>{masterHello.quote}</div>
      </div>
    )
  );
}
